import React, {Component} from 'react';
import Review from './Review/Review';
import './Reviews.scss';

class Reviews extends Component {
  render() {
    const {reviews} = this.props;
    let content;

    if (reviews.length) {
      content = reviews.map(rev => {
        return <Review content={rev.content} key={rev.id} url={rev.url} />;
      });
    } else {
      content = (
        <div className="review-no-reviews">
          <h2 className="review-no-reviews-title">No Reviews...</h2>
        </div>
      );
    }

    return (
      <div className="review">
        <h2 className="review-title">Reviews</h2>
        {content}
      </div>
    );
  }
}

export default Reviews;
